import { cr } from "fire-wind-water";
import Radio from "ant-design-vue/lib/radio"; // 加载 JS
import "ant-design-vue/lib/radio/style/css"; // 加载 CSS
import Vue from "vue";
import common from "./common";
Vue.use(Radio);
const radioImgMixin = {
  name: "sk-radio-img",
  props: {
    field: {},
    fieldValue: "",
    fieldResult: {},
    checkFlag: false,
    fieldStyle: {
      type: String,
      default: "style1"
    }
  },
  data() {
    return {
      fieldObj: {},
      isShow: false,
      title: "",
      desc: "",
      href: "",
      src: "",
      optionId: [] //当前选中的option
    };
  },
  watch: {
    checkFlag() {
      //校验
      this.fieldObj.dirty = true;
      //输出结果到父级
      common.updateData(this, this.fieldObj);
    }
  },
  created() {
    if (this.field.fieldLevel == 4) {
      this.field.errorRequired = ((window.$sk && window.$sk.$t) || function(){return '请选择';})('field.please_select');
    }
    this.fieldObj = new window.$sk.Radio(this.field);
    cr.each(this.fieldObj.listOptions, b => {
      cr.each(this.fieldObj.options, u => {
        if (b.optionId == u.optionId) {
          b.picUrl = u.picUrl;
          b.isOther = u.isOther;
        }
      });
      if (b.isDefault == 1) {
        this.optionId = b.optionId;
        this.fieldObj.setValue(b.optionId);
      }
    });
    //回填数据
    if (!this.fieldValue) {
      return;
    }
    cr.each(this.fieldObj.listOptions, b => {
      if (b.optionValue == this.fieldValue) {
        this.optionId = b.optionId;
        this.fieldObj.setValue(b.optionId);
      }
    });
  },
  methods: {
    inputBlur(e, o) {
      this.fieldObj.setOtherValue(o.optionId, e.target.value);
    },
    onChange(e) {
      this.optionId = e.target.value;
      this.fieldObj.setValue(e.target.value);
      let value ="";
      if(this.field.fieldLevel==1&&this.field.listDictId==0){
        this.fieldObj.listOptions.filter(b => {
          if(b.checked){
            value =b.optionValue;
          }
        });
      }
      this.$emit("change",{
        type:this.field.type,
        value:value?value:e.target.value,
        rulesInfo:this.field.rulesInfo,
        rulesCode:this.field.fieldName,
        sortBy:this.field.sortBy
      });
    },
    showImg(src, title, desc, href) {
      this.isShow = true;
      this.title = title;
      this.desc = desc;
      this.href = href;
      this.src = src;
    },
    close() {
      this.isShow = false;
      this.title = "";
      this.desc = "";
      this.href = "";
      this.src = "";
    }
  }
};
export default radioImgMixin;
